var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 5.75C3.49219 5.75 4.5 4.74219 4.5 3.5C4.5 2.25781 3.49219 1.25 2.25 1.25C1.00781 1.25 0 2.25781 0 3.5C0 4.74219 1.00781 5.75 2.25 5.75ZM2.25 16.25C1.00781 16.25 0 17.2578 0 18.5C0 19.7422 1.00781 20.75 2.25 20.75C3.49219 20.75 4.5 19.7422 4.5 18.5C4.5 17.2578 3.49219 16.25 2.25 16.25ZM0 11C0 9.75781 1.00781 8.75 2.25 8.75C3.49219 8.75 4.5 9.75781 4.5 11C4.5 12.2422 3.49219 13.25 2.25 13.25C1.00781 13.25 0 12.2422 0 11Z",
    fill: "#E34B31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.89689 6.125C8.55001 6.125 8.2172 5.98906 7.92657 5.74062L6.1922 3.96406C5.93593 3.70766 5.93593 3.2923 6.1922 3.03594L7.96876 1.25942C8.21486 1.01323 8.54879 0.875 8.89689 0.875H19.6875C20.4122 0.875 21 1.46281 21 2.1875V4.8125C21 5.53906 20.4141 6.125 19.6875 6.125H8.89689ZM22.6875 8.375H8.89689C8.54879 8.375 8.21486 8.51323 7.96876 8.75942L6.1922 10.5359C5.93593 10.7923 5.93593 11.2077 6.1922 11.4641L7.96876 13.2406C8.2172 13.4891 8.55001 13.625 8.89689 13.625H22.6875C23.4141 13.625 24 13.0391 24 12.3125V9.6875C24 8.96094 23.4141 8.375 22.6875 8.375ZM19.6875 15.875H8.89689C8.54879 15.875 8.21486 16.0132 7.96876 16.2594L6.1922 18.036C5.93593 18.2923 5.93593 18.7077 6.1922 18.9641L7.96876 20.7407C8.2172 20.9891 8.55001 21.125 8.89689 21.125H19.6875C20.4122 21.125 21 20.5372 21 19.8125V17.1875C21 16.4609 20.4141 15.875 19.6875 15.875Z",
    fill: "#E34B31"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuSelected);
export default __webpack_public_path__ + "static/media/menu-selected.3d23d3f63bc344d5b77a07159692baf3.svg";
export { ForwardRef as ReactComponent };